<div class="container flex-column" xmlns="http://www.w3.org/1999/html">
  <div class="d-flex justify-content-end mt-2">
    <img src="assets/Logo-eSPAJK.jpg" width="250" height="auto">
  </div>
  <div class="riplay-title">
    <h2 class="text-center mt-5 color-blue"><b>ELLISE Sales Dashboard</b></h2>
  </div>
  <div class="container mt-5 pt-4 form-header bg-white">
  </div>
</div>
<div class="container form-container pb-2">
  <div class="bg-white form-content pb-3 align-content-center mb-4">
    <p class="px-2 cursor-pointer text-primary" (click)="back()"><i class="bi bi-arrow-left"></i> Kembali</p>
    <form [formGroup]="formEndorse" (ngSubmit)="continue()" #form="ngForm">
      <div class="d-flex justify-content-around">
        <input class="bottom-border" type="date" formControlName="tanggalMulai">
        <i class="bi bi-arrow-right"></i>
        <input class="bottom-border" type="date" formControlName="tanggalEndorse"
               [ngClass]="{'text-danger' : (formEndorse.controls['tanggalEndorse'].dirty || form.submitted) && !formEndorse.controls['tanggalEndorse'].valid}"
               [min]="minDate" [max]="maxDate">
      </div>
      <div class="d-flex justify-content-around mt-3">
        <i class="fs-14 text-center description-input">Perubahan tanggal akad kredit hanya dapat dilakukan 1 (satu)
          kali.
          Tanggal akad kredit baru maksimal 30 hari sejak tanggal perubahan dan
          tidak dapat dilakukan jika terjadi perubahan premi.</i>
      </div>
      <div class="d-flex justify-content-center mt-4">
        <button class="btn button-primary" type="submit">Ubah Tanggal Akad Kredit</button>
      </div>
<!--      <div class="d-flex justify-content-center mt-4">-->
<!--        <button class="btn button-primary" (click)="generate()">GENGERATE LETTER</button>-->
<!--      </div>-->
<!--      <a class="btn btn-back mt-3 py-3 flex-grow-1" [hidden]="true" type="button" #btnAcceptance>UnduhAkseptasi</a>-->
<!--      <div class="d-flex justify-content-center mt-4">-->
<!--        <button class="btn button-primary" (click)="downloadDocument()">DOWNLOAD!!</button>-->
<!--      </div>-->
    </form>
  </div>
</div>
